import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { DashboardProvider, useDashboardContext } from '../../../context/DashboardContext';
import PartnerDashboardHero from '../../../components/Dashboard/PartnerDashboardHero';
import ReservationStatsCards from '../../../components/Dashboard/ReservationStatsCards';
import UpcomingReservations from '../../../components/Dashboard/UpcomingReservations';
import RecentReservationsAndReviews from '../../../components/Dashboard/RecentReservationsAndReviews';

const ActivityHomeContentInner = () => {
  const navigate = useNavigate();
  const {
    loading,
    stats,
    upcomingReservations,
    recentReservations,
    recentReviews,
    fetchDashboardData
  } = useDashboardContext();

  useEffect(() => {
    const token = localStorage.getItem('token_partner_activities');
    let businessId = localStorage.getItem('id_partner_activities');

    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        businessId = payload.business_id || payload._id || businessId;
      } catch (e) {
        console.error('Error decoding activity token:', e);
      }
    }

    if (businessId) {
      fetchDashboardData('activity', businessId, token);
    }
  }, [fetchDashboardData]);

  if (loading) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#067978] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6 sm:space-y-8 animate-in fade-in duration-700 pb-10">
      <Toaster position="top-right" />


      {/* Section 1: Poster Hero Slider */}
      <PartnerDashboardHero category="activity" />

      {/* Section 2: 2 Stat Cards (Active Reservation & Total Reservations) */}
      <ReservationStatsCards
        activeReservations={stats.activeReservations}
        totalReservations={stats.totalReservations}
      />

      {/* Section 3: Upcoming Reservations */}
      <UpcomingReservations
        upcomingReservations={upcomingReservations}
        navigate={navigate}
        bookingPath="/activity/booking"
      />

      {/* Section 4: 2-Column Grid (Recent Reservations & Recent Reviews) */}
      <RecentReservationsAndReviews
        recentReservations={recentReservations}
        recentReviews={recentReviews}
        navigate={navigate}
        bookingPath="/activity/booking"
        reviewsPath="/activity/reviews"
      />
    </div>
  );
};

const DashboardHome = () => (
  <DashboardProvider>
    <ActivityHomeContentInner />
  </DashboardProvider>
);

export default DashboardHome;
